import { CultureInfo } from "../../models/internationalization/culture-info.models";
import * as CountryLanguage from '@ladjs/country-language';

export class CultureInfoService {
	private static cultures: CultureInfo[];

	public get cultures(): CultureInfo[] {
		return CultureInfoService.cultures;
	}

	public constructor() {
		if (CultureInfoService.cultures) return;

		CultureInfoService.cultures = [];
		
		const languages = CountryLanguage.getLanguages();

		for (let i = 0; i < languages.length; i++) {
			if (!languages[i].countries || !languages[i].iso639_1 || languages[i].iso639_1.length == 0) continue;

			(languages[i].countries as string[]).forEach(c => {
				const country = CountryLanguage.getCountry(c);
				const countryName = languages[i].countries.length > 1 ? ` (${country.name})` : '';
				
				CultureInfoService.cultures.push({
					code: `${languages[i].iso639_1}-${country.code_2}`,
					name: languages[i].name[0] + countryName,
					nativeName: languages[i].nativeName[0] + countryName
				});
			});
		}
	}

	public findByCode(isoCode: string) {
		return this.cultures.filter(x => x.code == isoCode)[0];
	}
}
